import { Anchor, Card, Stack, Text } from "@mantine/core";
import { memo } from "react";
import type { ToolResultSources } from "../ToolResultRenderer.types";

interface SourcesStripProps {
  data: ToolResultSources;
}

function SourcesStripComponent({ data }: SourcesStripProps) {
  if (data.sources.length === 0) {
    return null;
  }

  return (
    <Stack gap="xs">
      {data.sources.map((source) => (
        <Card key={source.url} padding="sm" withBorder>
          <Anchor
            fw={500}
            href={source.url}
            rel="noopener noreferrer"
            size="sm"
            target="_blank"
            truncate="end"
          >
            {source.title}
          </Anchor>
          <Text c="dimmed" lineClamp={1} mt={2} size="xs">
            {source.excerpt}
          </Text>
        </Card>
      ))}
    </Stack>
  );
}

const SourcesStrip = memo(SourcesStripComponent);

export { SourcesStrip };
